import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  Card, Col,
  Form,
  ListGroup,
  Modal,
  Nav, Row,
  Spinner,
  Table,
} from "react-bootstrap";
import "../../App.css";
import { TsAdminContext } from "../../context/ts-admin";
import { toast } from "react-toastify";
import syncIcon from "../../assets/icons/sync_icon.svg";
import connected from "../../assets/icons/connect-icon.svg";
import disconnect from "../../assets/icons/disconnect-icon.svg";
import infomationIcon from "../../assets/icons/infomation_icon.svg";
import infomationGuildIcon from "../../assets/icons/infomation_guild_icon.svg";
import {
  createStorageProvider,
  getProviderDetail,
  ProviderData,
  updateSyncTime,
  disconnectStorageProvider,
  updateStorageProvider,
  TableField,
  syncImmediately, updateTableField,
} from "../../api-service/storage-provider";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import dayjs from "dayjs";
import FormulaModal from "./formula-input-modal";
import { Checkbox, FormControlLabel, Radio } from "@mui/material";
import { CONNECT_TYPE_EX } from "../../common";
import { useNavigate, useSearchParams } from "react-router-dom";
import AccessControlLog from "./access-control-log";
import TerminalMapping from "./terminal-mapping";

type FormulaValue = {
  index: any;
  convertRule: string;
  notSend: boolean;
  convertMethod?: number;
  name: string;
};

const TableFieldSalesforce = [
    {
        Name: "メール",
        ApiName: "Email__c",
        Index: 1,
        Type: "",
        ConvertRule: "",
        NotSend: false,
    },
    {
        Name: "社員ID",
        ApiName: "EmpId__c",
        Index: 2,
        Type: "",
        ConvertRule: "",
        NotSend: false,
    },
    {
        Name: "社員コード	",
        ApiName: "EmpCode__c",
        Index: 3,
        Type: "",
        ConvertRule: "",
        NotSend: false,
        ConvertMethod: 1
    },
    // {
    //   Name: "ログキー",
    //   ApiName: "LogKey__c",
    //   Index: 3,
    //   Type: "",
    //   ConvertRule: "",
    //   NotSend: false,
    // },
    {
        Name: "ログ日時",
        ApiName: "LogDate__c",
        Index: 4,
        Type: "",
        ConvertRule: "",
        NotSend: false,
    },
    {
        Name: "ログ種別",
        ApiName: "LogType__c",
        Index: 5,
        Type: "",
        ConvertRule: "",
        NotSend: false,
    },
    {
        Name: "備考",
        ApiName: "Note__c",
        Index: 6,
        Type: "",
        ConvertRule: "",
        NotSend: false,
    },
];

const TableFieldLandScope = [
    {
        Name: "社員コード	",
        ApiName: "EmpCode__c",
        Index: 1,
        Type: "",
        ConvertRule: "",
        NotSend: false,
        ConvertMethod: 1
    },
];
type DataSourceOption = "s3" | "window" | "lan_scope";

const getTableFieldsByDataSource = (ds: DataSourceOption): TableField[] => {
  return ds === "lan_scope" ? TableFieldLandScope : TableFieldSalesforce;
};

export function ServerConnectPage() {
  const [orgInfo, _, userInfo] = useContext(TsAdminContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [obtainType, setObtainType] = useState<DataSourceOption>('s3');
  const [isSending, setIsSending] = useState<Boolean>(false);
  const [tableFields, setTableFields] = useState<TableField[]>(TableFieldSalesforce);

  const [isEditing, setIsEdting] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowOptionChangeModal, setIsShowOptionChangeModal] = useState(false);
  const [isShowDisconnectModal, setIsShowDisconnectModal] = useState(false);
  const [isShowDisconnectModalLS, setIsShowDisconnectModalLS] = useState(false);
  const [isShowInputLs, setIsShowInputLs] = useState(false);
  const [modalContent, setModalContent] = useState(
    `手動で、データの取得・送信を実行します。\n よろしいですか？`,
  );
  const [isShowDataExplainModal, setIsShowDataExplainModal] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [isSynced, setIsSynced] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [hasHeaderCsv, setHasHeaderCsv] = useState(false);
  const [awsFields, setAwsFields] = useState([
    { name: "access_key", label: "Access Key ID", value: "" },
    { name: "secret_key", label: "Secret Access Key", value: "" },
    { name: "region", label: "Region", value: "" },
    { name: "bucket", label: "Bucket", value: "" },
    { name: "path", label: "Prefix/Path", value: "" },
  ]);
  const [lanscopeFields] = useState([
    { name: "lanscope_token", label: "Lanscope Token", value: "" },
  ]);
  const [requestBody, setRequestBody] = useState<{
    access_key: string | null;
    secret_key: string | null;
    provider: "aws" | null;
    path: string | null;
    bucket: string | null;
    region: string | null;
    data_source: "s3" | "window" | 'lan_scope';
    lanscope_access_token: string | null;
    enable_event_rule: boolean;
  }>({
    access_key: "",
    secret_key: "",
    provider: "aws",
    path: "",
    bucket: "",
    region: "",
    data_source: "window",
    enable_event_rule: false,
    lanscope_access_token: ""
  });

  const [isRegistering, setIsRegistering] = useState<boolean | null>(null);
  const [fieldErrors, setFieldErrors] = useState<Record<string, boolean>>({});
  const [providerData, setProviderData] = useState<ProviderData | null>(null);
  const [documentDownloadUrl, setDocumentDownloadUrl] = useState<string>("");
  const [scheduleTime, setScheduleTime] = useState<{
    hour: string;
    minute: string;
  } | null>(null);
  const [timeValue, setTimeValue] = useState<dayjs.Dayjs | null>(null);
  const [duplicateIndexes, setDuplicateIndexes] = useState<number[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [currentFormula, setCurrentFormula] = useState<FormulaValue>({
    index: undefined,
    convertRule: "",
    notSend: false,
    convertMethod: 1,
    name: ""
  });
  const [initialFormula, setInitialFormula] = useState<
    Record<string, FormulaValue>
  >({});
  const [currentField, setCurrentField] = useState<string | null>(null);
  const [selectingOption, setSelectingOption] = useState<string | null>(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const tab: "settings" | "logs" | "terminal-employee-mapping" =
    tabParam === "settings" || tabParam === "logs" || tabParam === "terminal-employee-mapping"
      ? (tabParam as "settings" | "logs" | "terminal-employee-mapping")
      : "settings";

  const [activeTab, setActiveTab] = useState<
    "settings" | "logs" | "terminal-employee-mapping"
  >(tab);

  const [isLanscopeInvalid, setIsLanscopeInvalid] = useState(false);

  const TIME_SENDING_OPTIONS = [
    { value: "false", label: "送信しない" },
    { value: "true", label: "毎日" },
  ]

  const DATA_SOURCE_OPTIONS: {
    value: DataSourceOption;
    label: string | JSX.Element;
  }[] = [
    { value: "s3", label: "定期取得" },
    {
      value: "window",
      label: (
        <>
          自動受信
        </>
      ),
    },
    { value: "lan_scope", label: "LANSCOPEクラウド" },
  ];

  useEffect(() => {
    const { Hour, Minute } = providerData || {};
    if (isEditing && Hour && Minute && Hour !== "" && Minute !== "") {
      const time = dayjs(
        `${Hour.padStart(2, "0")}:${Minute.padStart(2, "0")}`,
        "HH:mm",
      );
      setTimeValue(time);
      setScheduleTime({ hour: Hour, minute: Minute });
    } else {
      setTimeValue(null);
    }
  }, [isEditing, providerData]);

  useEffect(() => {
    if (
      providerData?.AccessKey === "" &&
      obtainType === "window" &&
      providerData === null
    ) {
      setIsConnected(false);
      setIsEdting(true);
    }
    if (providerData?.Hour === "" && obtainType === "window" && providerData.EnableEventRule === true) {
      setIsConnected(false);
      setIsEdting(true);
    }
  }, [providerData, obtainType]);

  useEffect(() => {
    if (
      providerData?.DataSource === "s3" &&
      obtainType === "s3" &&
      providerData.AccessKey &&
      providerData !== null
    ) {
      setIsConnected(true);
    }
    if (
      providerData?.DataSource === "s3" &&
      obtainType === "window" &&
      providerData !== null &&
      providerData.AccessKey !== ""
    ) {
      setIsConnected(true);
    }
  }, [obtainType]);

  useEffect(() => {
    if (providerData?.Hour && providerData?.Minute) {
      setTimeValue(
        dayjs(`${providerData.Hour}:${providerData.Minute}`, "HH:mm"),
      );
    } else {
      setTimeValue(dayjs(""));
    }
  }, [providerData]);

  useEffect(() => {
    if (providerData?.TableFields) {
        if(providerData.DataSource === 'lan_scope') {
            const initial = providerData.TableFields.reduce((acc, item) => {
                acc[item.ApiName] = {
                    index: 0,
                    convertRule: item.ConvertRule || "",
                    notSend: item.NotSend,
                    convertMethod: item?.ConvertMethod ?? 1,
                    name: item?.ApiName
                };
                return acc;
            }, {} as Record<string, FormulaValue>);

            setInitialFormula(initial);

            const updatedFields = providerData.TableFields.map((field) => ({
                ...field,
                ConvertRule: initial[field.ApiName]?.convertRule || "",
                Name: field.Name,
            }));

            setTableFields(updatedFields);
        } else {
            const initial = providerData.TableFields.reduce((acc, item) => {
                acc[item.ApiName] = {
                    index: 0,
                    convertRule: item.ConvertRule || "",
                    notSend: item.NotSend,
                    convertMethod: item?.ConvertMethod ?? 1,
                    name: item?.ApiName
                };
                return acc;
            }, {} as Record<string, FormulaValue>);

            setInitialFormula(initial);

            const updatedFields = providerData.TableFields.map((field) => ({
                ...field,
                ConvertRule: initial[field.ApiName]?.convertRule || "",
                Name:
                    isEditing &&
                    ["EmpId__c", "Email__c", "EmpCode__c"].includes(field.ApiName)
                        ? `${field.Name}`
                        : field.Name,
            }));
            setTableFields(updatedFields);
        }

    }
  }, [providerData?.TableFields, isEditing]);

  useEffect(() => {
    if (tableFields.length === 0) return;
    const indexCount: Record<number, number> = {};
    tableFields.forEach((field) => {
      indexCount[field.Index] = (indexCount[field.Index] || 0) + 1;
    });
    const duplicates = Object.keys(indexCount)
      .filter((key) => indexCount[+key] > 1)
      .map((key) => +key);

    setDuplicateIndexes(duplicates);
  }, [tableFields, currentFormula]);

  useEffect(() => {
    let mounted = true;
    if (!orgInfo) {
      return;
    }

    let isAbleToAccess = orgInfo.currentAccount.useAccessControl &&
      orgInfo.currentOrg.ConnectType !== CONNECT_TYPE_EX;
    if (Boolean(isAbleToAccess) === false) {
      navigate("/404", { replace: true });
    }

    const fetchProviders = async () => {
      if (!mounted) return;
      setIsLoading(true);
      setIsConnected(false);
      try {
        const provider = await getProviderDetail({
          TargetOrg: `${localStorage.getItem('target-org') || orgInfo?.currentOrg?.OrgId}`,
        });
        console.log(provider,11)
        const data = provider?.data ?? null;
        setDocumentDownloadUrl(provider?.download_url)
        if (!data || Object.keys(data).length === 0) {
          if (!mounted) return;
          setIsEdting(true);
          setIsConnected(false);
          setIsRendered(true);
          return;
        }

        if (!mounted) return;
        setProviderData(data);
        const hourRaw = data.Hour ?? "";
        const minuteRaw = data.Minute ?? "";
        const hourStr =
          hourRaw === "" ? "00" : String(hourRaw).padStart(2, "0");
        const minuteStr =
          minuteRaw === "" ? "00" : String(minuteRaw).padStart(2, "0");
        const hourNum = Number(hourRaw);
        const minuteNum = Number(minuteRaw);
        setHasHeaderCsv(data.HasHeaderCsv);
        setObtainType(data.DataSource as DataSourceOption);
        setIsSending(data.EnableEventRule);
        if (data.DataSource === "window" ) {
          setScheduleTime({ hour: hourStr, minute: minuteStr });
          setRequestBody((prev) => ({
            ...prev,
            data_source: data.DataSource as DataSourceOption,
            access_key: data.AccessKey,
            secret_key: data.SecretKey,
            bucket: data.Bucket,
            path: data.Path,
            provider: "aws",
            region: data.Region,
            has_header_csv: data.HasHeaderCsv,
            enable_event_rule: data.EnableEventRule,
            lanscope_access_token: data.LanScopeAccessToken
          }));
          setIsConnected(true);
          setIsEdting(false);
          setIsRegistering(false);
          if (data.AccessKey === "" && data.Hour === "" && providerData?.EnableEventRule === true) {
            data.DataSource = "s3";
            setIsConnected(false);
            setIsEdting(true);
            setIsRegistering(false);
          }
        }
        else if (data.DataSource === 'lan_scope') {
          setScheduleTime({ hour: hourStr, minute: minuteStr });
          setRequestBody((prev) => ({
            ...prev,
            data_source: 'lan_scope',
            access_key: data.AccessKey,
            secret_key: data.SecretKey,
            bucket: data.Bucket,
            path: data.Path,
            provider: "aws",
            region: data.Region,
            has_header_csv: data.HasHeaderCsv,
            enable_event_rule: data.EnableEventRule,
            lanscope_access_token: data.LanScopeAccessToken
          }));
          setIsConnected(true);
          setIsEdting(false);
          setObtainType('lan_scope')
        }
        else if (data.DataSource === "s3") {
          setAwsFields((prev) =>
            prev.map((field) => ({
              ...field,
              value: getValueFromProvider(field.name, data),
            })),
          );
          setRequestBody((prev) => ({
            ...prev,
            data_source: "s3",
            region: data.Region,
            access_key: data.AccessKey,
            secret_key: data.SecretKey,
            path: data.Path,
            bucket: data.Bucket,
            has_header_csv: data.HasHeaderCsv,
            enable_event_rule: data.EnableEventRule,
            lanscope_access_token: data.LanScopeAccessToken
          }));
          if (data.AccessKey !== "") {
            setIsConnected(true);
          } else if (data.AccessKey === "") {
            setIsConnected(false);
          }
          setIsRegistering(false);
          if (
            !Number.isNaN(hourNum) &&
            !Number.isNaN(minuteNum) &&
            data.AccessKey !== ""
          ) {
            setScheduleTime({ hour: hourStr, minute: minuteStr });
            setIsEdting(false);
          } else {
            setIsEdting(true);
            setIsConnected(false);
            setIsRegistering(false);
          }
          setRequestBody((prev) => ({ ...prev, data_source: "s3" }));
          setIsRegistering(false);
        } else {
          setIsConnected(false);
          setIsEdting(true);
        }

        setIsRendered(true);
      } catch (error) {
        console.error("fetchProviders error", error);
        if (!mounted) return;
        setIsRendered(true);
        setIsConnected(false);
        setIsRegistering(false);
        setIsEdting(false);
      } finally {
        if (!mounted) return;
        setIsLoading(false);
      }
    };

    fetchProviders();

    return () => {
      mounted = false;
    };
  }, [orgInfo]);

  useEffect(() => {
    if (obtainType === "s3") {
      setRequestBody((prev) => ({
        ...prev,
        data_source: "s3",
      }));
    } else if (obtainType === "window") {
      setRequestBody((prev) => ({
        ...prev,
        data_source: "window",
      }));
    } else if (obtainType === "lan_scope") {
      setRequestBody((prev) => ({
        ...prev,
        data_source: "lan_scope",
      }));
      setTableFields(getTableFieldsByDataSource("lan_scope"));
    }
    setFieldErrors({});
  }, [obtainType]);

  useEffect(() => {
    if (userInfo) {
      setIsSuperAdmin(userInfo.isSuperAdmin);
    }
  }, [userInfo]);

  useEffect(() => {
    setActiveTab(tab);
    searchParams.set('tab', tab);
  }, [tab]);

  const getValueFromProvider = (
    fieldName: string,
    data: ProviderData,
  ): string => {
    switch (fieldName) {
      case "access_key":
        return data.AccessKey || "";
      case "secret_key":
        return data.SecretKey || "";
      case "region":
        return data.Region || "";
      case "bucket":
        return data.Bucket || "";
      case "path":
        return data.Path || "";
      default:
        return "";
    }
  };

  useEffect(() => {
    console.log(isEditing);
    
  },[isEditing])

  const handleCloseModal = () => {
    setIsSynced(false);
    setIsShowModal(false);
    setModalContent(
      "手動で、データの取得・送信を実行します。\n よろしいですか？",
    );
  };

  const handleCloseOptionChangeModal = () => {
    setObtainType(providerData?.DataSource as DataSourceOption)
    setIsShowOptionChangeModal(false);
  };

  const handleCloseDisconnectModal = () => {
    setIsShowDisconnectModal(false);
  };

  const handleCloseDisconnectModalLS = () => {
    setIsShowDisconnectModalLS(false);
  };

  const handleShowDisconnectModalLS = () => {
    setIsShowDisconnectModalLS(true);
  };

  const handleShowInputLs = () => {
    if (
      providerData?.LanScopeAccessToken !== "" &&
      providerData?.LanScopeAccessToken !== undefined &&
      providerData?.LanScopeAccessToken
    ) {
      handleShowDisconnectModalLS();
    } else {
      setIsShowInputLs(true);
    }
    setIsLanscopeInvalid(false);
  };

  const handleDisconnectAWS = async () => {
    setIsShowDisconnectModal(false);
    setIsLoading(true);
    try {
      const res = await disconnectStorageProvider();
      if (res?.message) {
        toast.success(res?.message);
        setIsConnected(false);
        setIsRegistering(false);
        setAwsFields((prevFields) =>
          prevFields.map((field) => ({
            ...field,
            value: "",
          })),
        );
        setScheduleTime(null);
        setProviderData(res.data as ProviderData);
        setIsLoading(false);
        setIsEdting(true);
        setIsRegistering(false);
        setIsConnected(false);
      }
    } catch (error) {
      toast.error("ERROR");
      setIsLoading(false);
    }
  };

  const handleCloseDataExplainModal = () => {
    setIsShowDataExplainModal(false);
  };

  const handleSyncImmediately = async () => {
    try {
      setIsLoading(true);
      const sync = await syncImmediately();
      toast.success(sync.message);
      setModalContent("データの取得・送信が完了しました。");
      setIsSynced(true);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error(String(error));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleRegister = () => {
    if (providerData?.AccessKey === "" || !providerData) {
      setRequestBody((prev) => ({
        ...prev,
        access_key: providerData?.AccessKey || null,
        secret_key: "",
        provider: "aws" as const,
        path: "",
        bucket: "",
        region: "",
        data_source: "s3",
      }));
      setAwsFields((prevFields) =>
        prevFields.map((field) => ({
          ...field,
          value: "",
        })),
      );
      setIsRegistering(true);
    } else if (isConnected && providerData?.AccessKey !== "") {
      setIsShowDisconnectModal(true);
    }
  };

  const validateRequiredFields = () => {
    const requiredFields: { key: keyof typeof requestBody; label: string }[] = [
      { key: "access_key", label: "Access Key" },
      { key: "secret_key", label: "Secret Key" },
      { key: "region", label: "Region" },
      { key: "bucket", label: "Bucket" },
      { key: "path", label: "Prefix/Path" },
    ];

    const errors: Record<string, boolean> = {};
    let hasError = false;

    for (const field of requiredFields) {
      const value = requestBody[field.key];
      if (typeof value !== "string" || value.trim() === "") {
        errors[field.key] = true;
        hasError = true;
      }
    }

    setFieldErrors(errors);
    return !hasError;
  };

  const handleCreateStorage = async () => {
    if (!validateRequiredFields()) {
      return;
    }
    try {
      setIsLoading(true);
      setIsRegistering(true);
      if (!providerData?.OrgId || providerData?.OrgId == null) {
        const res = (await createStorageProvider(requestBody)) as {
          message: string;
          data: Record<string, any>;
        };
        if (res?.message && res?.data) {
          toast.success(res.message);
          setIsConnected(true);
          setIsRegistering(false);
          setProviderData(res.data as ProviderData);
          setObtainType('s3');
        }
      } else {
        const res = (await updateStorageProvider(requestBody)) as {
          message: string;
          data: Record<string, any>;
        };
        if (res?.message && res?.data) {
          toast.success(res.message);
          setIsConnected(true);
          setIsRegistering(false);
          setObtainType('s3');
          setProviderData(res?.data as ProviderData);
        }
      }
      setIsLoading(false);
    } catch (e) {
      setIsEdting(false);
      setIsConnected(false);
      setIsLoading(false);
      toast.error(JSON.stringify(e));
    }
  };

  const handleSaveConnection = async () => {
    if (
      !scheduleTime?.hour &&
      !scheduleTime?.minute &&
      requestBody.enable_event_rule
    ) {
      toast.error("送信設定時間を入力してください。");
      return;
    }
    if (duplicateIndexes.length > 0) {
      toast.error(`取得列が重複しています: ${duplicateIndexes.join(", ")}。`);
      return;
    }
    setIsLoading(true);
    try {
      if (providerData !== null) {
        const payload: any = {
          data_source: obtainType,
          hour: String(scheduleTime?.hour ?? ""),
          minute: String(scheduleTime?.minute ?? ""),
        };
        payload.has_header_csv = hasHeaderCsv;
        payload.table_fields = tableFields ;
        const res = await updateSyncTime(payload);
        if (res?.data) {
          if (obtainType === "window" || obtainType === "lan_scope") {
            requestBodyRef.current.data_source = obtainType;
            const bodyWithTime = {
              ...requestBodyRef.current,
              hour: scheduleTime?.hour || "",
              minute: scheduleTime?.minute || "",
            };
            let providerDataProcess: any;
            if (!providerData.OrgId) {
              providerDataProcess=   await createStorageProvider(bodyWithTime);
            } else {
              providerDataProcess = await updateStorageProvider(bodyWithTime);
            }   
            setProviderData((prev) => {
              const newData = providerDataProcess.data;
              return {
                ...newData,
                AccessKey: prev?.AccessKey || "",
                DataSource: res.data.DataSource,
              };
            });
          } else {            
            let res: any;
            requestBody.data_source = obtainType;
            if (providerData.OrgId === "") {
              res = await createStorageProvider(requestBody);
            } else {
              res = await updateStorageProvider(requestBody);
            }
            setProviderData(res.data);
          }
          setIsEdting(false);
          setIsRegistering(false);
          setIsConnected(true);
          toast.success(res.message);
          setIsShowInputLs(false);
        }
      } else {
        const payload: any = {
          data_source: obtainType,
          hour: String(scheduleTime?.hour ?? ""),
          minute: String(scheduleTime?.minute ?? ""),
        };
        payload.table_fields = tableFields;
        if (obtainType === 'lan_scope') {
          payload.lanscope_access_token = requestBodyRef.current.lanscope_access_token;
        }
        const res = (await createStorageProvider(payload)) as {
          message: string;
          data: ProviderData;
        };
        setProviderData(res.data);
        setIsEdting(false);
        setIsRegistering(false);
        setIsConnected(true);
        setIsShowInputLs(false);
        toast.success("送信設定時間を更新しました。");
      }

      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);

      if (typeof error === "object" && error !== null && "message" in error) {
        toast.error(String((error as { message: string }).message));
      } else if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error(String(error));
      }
    }
  };

  const handleOpenFormulaModal = (row: TableField) => {
    setCurrentField(row.ApiName);
    setCurrentFormula({
      index: row.Index ?? undefined,
      convertRule: row.ConvertRule.trim() ?? "",
      notSend: row.NotSend,
      convertMethod: row.ConvertMethod,
      name: row.Name
    });
    setShowModal(true);
  };

  const handleSaveFormula = (val: FormulaValue) => {
    if (currentField) {
      setTableFields((prev) =>
        prev.map((field) =>
          field.Name === currentFormula.name
            ? {
                ...field,
                Index: val.index,
                ConvertRule: val.convertRule,
                NotSend: val.notSend,
                ...(field.ApiName === 'EmpCode__c' && { ConvertMethod: currentFormula.convertMethod }),
              }
            : field,
        ),
      );
    }
    setShowModal(false);
  };

  const handleConfirmSelectOption = () => {
    if (selectingOption) {
      setObtainType(selectingOption as DataSourceOption);
      setRequestBody((prev) => {
        const newState = {
          ...prev,
          data_source: selectingOption as DataSourceOption,
        };
        requestBodyRef.current = newState;
        return newState;
      });


      setTableFields(
        obtainType !== "lan_scope"
          ? [...tableFields]
          : [...(getTableFieldsByDataSource(selectingOption as DataSourceOption))],
      );
      setIsShowOptionChangeModal(false);
    }
  };

  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab as "settings" | "logs" | "terminal-employee-mapping");
    setSearchParams({ tab: newTab });
  };


  const handleObtainTypeChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const ds = e.target.value as DataSourceOption;
      if (providerData?.OrgId !== "" && providerData) {
        setSelectingOption(ds);
        const currentDs = providerData?.DataSource as DataSourceOption | undefined;

        if (currentDs === "s3" && (ds === "lan_scope" || ds === 'window') && providerData.AccessKey !== "") {
          setIsShowOptionChangeModal(true);
          return;
        }
        if (currentDs === "window" && (ds === "s3" || ds === 'lan_scope')) {
          setIsShowOptionChangeModal(true);
          return;
        }
        if (currentDs === "lan_scope" && (ds === "s3" || ds === 'window')) {
          setIsShowOptionChangeModal(true);
          return;
        }
        setObtainType(e.target.value as DataSourceOption);
        setRequestBody((prev) => {
          const newState = {
            ...prev,
            data_source: ds,
          };
          requestBodyRef.current = newState;
          return newState;
        });
        if (ds === "lan_scope") {
          setTableFields(getTableFieldsByDataSource("lan_scope"));
        } else {
          setTableFields(providerData.TableFields);
        }
        return;
      }

      setObtainType(e.target.value as DataSourceOption);
      setRequestBody((prev) => {
        const newState = {
          ...prev,
          data_source: ds,
        };
        requestBodyRef.current = newState;
        return newState;
      });
      if (ds === "lan_scope") {
        setTableFields(getTableFieldsByDataSource("lan_scope"));
      } else {
        setTableFields(getTableFieldsByDataSource(ds));
      }
    },
    [providerData]
  );

  const [showModalMapping, setShowModalMapping] = useState(false);

  const handleMapping = async () => {
    if (duplicateIndexes.length > 0) {
      toast.error(`取得列が重複しています: ${duplicateIndexes.join(", ")}。`);
      return;
    }
    const tableFieldsWithConverMethod = tableFields.map(field => {
      const fieldObj = { ...field };
      
      return fieldObj;
    });    
    
    setIsLoading(true);
    try {
      const payload: any = {
        table_fields: tableFieldsWithConverMethod,
        has_header_csv: hasHeaderCsv,
      };
      const res = (await updateTableField(payload)) as {
        message: string;
        data: ProviderData;
      };

      // Keep UI state in sync with what backend persisted to avoid resetting type/shape
      setProviderData(res.data);
      if (Array.isArray(res.data.TableFields)) {
        setTableFields(res.data.TableFields as any);
      }
      if (res.data?.DataSource) {
        setObtainType(res.data.DataSource as any);
      }
      setHasHeaderCsv(Boolean(res.data?.HasHeaderCsv));

      setIsEdting(false);
      setIsRegistering(false);
      setIsConnected(true);
      toast.success("マッピングを保存しました。");
      setShowModalMapping(false);
    } catch (error) {
      if (error instanceof Error) {
        toast.error(error.message);
      } else {
        toast.error(String(error));
      }
    } finally {
      setIsLoading(false);
    }
  }

  const requestBodyRef = useRef(requestBody);

  const handleClearLsToken = async () => {
    const newRequestBody = {
      ...requestBody,
      lanscope_access_token: "",
    };
    requestBodyRef.current = newRequestBody;
    handleSaveConnection();
    setRequestBody(newRequestBody);
    setIsShowDisconnectModalLS(false);
    setIsEdting(false);
  };

  useEffect(() => {
    if (providerData?.LanScopeAccessToken !== undefined) {
      setRequestBody(prev => ({
        ...prev,
        lanscope_access_token: providerData.LanScopeAccessToken
      }));
    }
  }, [providerData]);

  return (
    <div>
      {isLoading && (
        <div className="provider-loading">
          <Spinner variant="light" />
        </div>
      )}
      {isRendered && (
        <Fragment>
          <Modal
            className="pt-5 storage-cmp"
            show={isShowModal}
            onHide={handleCloseModal}
          >
            <Modal.Header closeButton>
              {!isSynced ? (
                "データの取得・送信"
              ) : (
                <>
                  <img
                    src={infomationIcon}
                    alt="info"
                    className="me-1"
                    style={{ order: 0 }}
                  />
                  確認
                </>
              )}
            </Modal.Header>
            <Modal.Body>
              {modalContent.split("\n").map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}
            </Modal.Body>
            <Modal.Footer className="modal-footer">
              {!isSynced && (
                <>
                  <Button
                    variant="light"
                    size="sm"
                    className="modal-btn modal-cancel-btn"
                    onClick={handleCloseModal}
                  >
                    キャンセル
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    className="modal-btn"
                    onClick={handleSyncImmediately}
                  >
                    実行
                  </Button>
                </>
              )}
              {isSynced && (
                <Button
                  variant="light"
                  size="sm"
                  className="modal-btn modal-cancel-btn"
                  onClick={handleCloseModal}
                >
                  OK
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Modal
            className="pt-5 storage-cmp"
            show={isShowOptionChangeModal}
            onHide={handleCloseOptionChangeModal}
          >
            <Modal.Header closeButton>
              <img
                src={infomationIcon}
                alt="info"
                className="me-1"
                style={{ order: 0 }}
              />
              確認
            </Modal.Header>
            <Modal.Body>
              <span>取得方法を変更します。</span>
              <br />
              <span style={{ order: 1 }}>よろしいですか？</span>
            </Modal.Body>
            <Modal.Footer className="modal-footer">
              <>
                <Button
                  variant="light"
                  size="sm"
                  className="modal-btn modal-cancel-btn"
                  onClick={handleCloseOptionChangeModal}
                >
                  キャンセル
                </Button>
                <Button
                  variant="primary"
                  size="sm"
                  className="modal-btn"
                  onClick={handleConfirmSelectOption}
                >
                  変更
                </Button>
              </>
            </Modal.Footer>
          </Modal>
          <Modal
            className="pt-5 storage-cmp"
            show={isShowDisconnectModal}
            onHide={handleCloseDisconnectModal}
          >
            <Modal.Header closeButton>
              <img
                src={infomationIcon}
                alt="info"
                className="me-1"
                style={{ order: 0 }}
              />
              確認
            </Modal.Header>
            <Modal.Body>
              接続を解除します。
              <br />
              よろしいですか？
            </Modal.Body>
            <Modal.Footer className="modal-footer">
              <>
                <Button
                  variant="light"
                  size="sm"
                  className="modal-btn modal-cancel-btn"
                  onClick={handleCloseDisconnectModal}
                >
                  キャンセル
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modal-btn"
                  onClick={handleDisconnectAWS}
                >
                  解除
                </Button>
              </>
            </Modal.Footer>
          </Modal>
          <Modal
            className="pt-5 storage-cmp"
            show={isShowDisconnectModalLS}
            onHide={handleCloseDisconnectModalLS}
          >
            <Modal.Header closeButton>
              <img
                src={infomationIcon}
                alt="info"
                className="me-1"
                style={{ order: 0 }}
              />
              確認
            </Modal.Header>
            <Modal.Body>
              接続を解除します。
              <br />
              よろしいですか？
            </Modal.Body>
            <Modal.Footer className="modal-footer">
              <>
                <Button
                  variant="light"
                  size="sm"
                  className="modal-btn modal-cancel-btn"
                  onClick={handleCloseDisconnectModalLS}
                >
                  キャンセル
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="modal-btn"
                  onClick={handleClearLsToken}
                >
                  解除
                </Button>
              </>
            </Modal.Footer>
          </Modal>
          <Modal
            className="salesforce-fields-connected_explain_modal"
            show={isShowDataExplainModal}
            onHide={handleCloseDataExplainModal}
            centered
          >
            <Modal.Header closeButton>送信データ形式について</Modal.Header>

            <Modal.Body>
              <ul className="list-disc pl-4 text-sm text-gray-700">
                <li>
                  <div>メール</div>
                  <div>Salesforceユーザーに登録されているメールアドレス</div>
                </li>

                <li>
                  <div>社員ID</div>
                  <div>TeamSpiritの勤怠社員オブジェクトのid</div>
                </li>

                <li>
                  <div>社員コード</div>
                  <div>勤怠社員の社員コード</div>
                </li>

                <li>
                  <div>ログ日時</div>
                  <div>入館・退館の日時で形式はYYYY-MM-DD HH:MM</div>
                </li>

                <li>
                  <div>ログ種別</div>
                  <div>入館の場合は1、退館の場合は2</div>
                </li>
              </ul>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="light"
                size="sm"
                className="modal-btn modal-cancel-btn"
                onClick={handleCloseDataExplainModal}
              >
                閉じる
              </Button>
            </Modal.Footer>
          </Modal>
          <div className="d-flex" style={{ minHeight: "100vh" }}>
            <Nav className="flex-column bg-white p-3 nav-bar-container">
              <Nav.Link
                className={activeTab === "settings" ? "active" : ""}
                onClick={() => handleTabChange("settings")}
              >
                設定
              </Nav.Link>
              <Nav.Link
                className={
                  activeTab === "terminal-employee-mapping" ? "active" : ""
                }
                onClick={() => handleTabChange("terminal-employee-mapping")}
              >
                端末社員マッピング
              </Nav.Link>
              <Nav.Link
                className={activeTab === "logs" ? "active" : ""}
                onClick={() => handleTabChange("logs")}
              >
                ログ確認
              </Nav.Link>
            </Nav>

            {activeTab === "settings" && (
              <div className="provider-settings flex-grow-1 p-4">
                <Card className="card-container">
                  <Card.Body className="page-title">
                    入退館のデータの取得・送信の設定
                  </Card.Body>
                </Card>

                {((!providerData?.Hour && !providerData?.Minute) ||
                  (providerData?.Hour === "" && providerData?.Minute === "") ||
                  !providerData) && (
                  <>
                    <div className="mt-3 time-unset-container">
                      <div>
                        <img src={infomationGuildIcon} alt="info" />
                      </div>
                      <div>
                        <span>
                          取得の設定を行なってください <br />
                        </span>

                        <span>
                          まだ取得設定が行われていません。以下より設定を行い、「保存」を押下してください。
                        </span>
                      </div>
                    </div>
                  </>
                )}

                {isSuperAdmin || (
                  <div className="d-flex justify-content-end">
                    <Button
                      className={`bg-white sync-button card-content ${
                        isEditing ? "button-disabled" : ""
                      }`}
                      disabled={isEditing}
                      onClick={() => {
                        setIsShowModal(true);
                      }}
                    >
                      <img src={syncIcon} alt="" />
                      <span>手動でデータ取得・送信を行う</span>
                    </Button>
                  </div>
                )}

                <Card className="mt-3 card-container">
                  <Form>
                    <ListGroup variant="flush">
                      <div className="align-items-center mt-1"></div>
                      <ListGroup.Item className="w-100 d-flex align-items-center">
                        <div className="w-25 py-2 item-label">取得方法</div>
                        <div className="w-100 d-flex gap-4">
                          {DATA_SOURCE_OPTIONS.map((opt) => (
                            <div
                              key={opt.value}
                              className="form-check form-check-inline"
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="obtainType"
                                id={`storage-${opt.value}`}
                                value={opt.value}
                                checked={obtainType === opt.value}
                                onChange={handleObtainTypeChange}
                                disabled={!isEditing || isSuperAdmin}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`storage-${opt.value}`}
                              >
                                {opt.label}
                              </label>
                                {
                                    opt.value == 'window' &&
                                    <button
                                        onClick={() => {
                                            if (documentDownloadUrl) {
                                                window.open(documentDownloadUrl, "_blank");
                                            } else {
                                                return;
                                            }
                                        }}
                                        type="button"
                                        className="btn-download-document fs-13"
                                    >
                                        （関連ファイル）
                                    </button>
                                }
                            </div>

                          ))}
                        </div>
                      </ListGroup.Item>

                      {obtainType == "s3" && (
                        <ListGroup.Item className="w-100 d-flex align-items-start relative-container">
                          <div className="w-25 item-label">接続</div>
                          <div className="w-100 d-flex flex-column gap-2">
                            <span className="guild-text">
                              取得するサーバー先を設定してください
                            </span>
                            <div className="d-flex gap-2 connection-container">
                              {isConnected &&
                                providerData?.AccessKey !== "" && (
                                  <>
                                    <span>AWS</span>
                                    <span>に接続中</span>
                                  </>
                                )}
                              <Button
                                disabled={!isEditing || isSuperAdmin}
                                className={`bg-white sync-button card-content ${
                                  !isEditing ? "button-disabled" : ""
                                }`}
                                onClick={handleRegister}
                              >
                                <img
                                  src={
                                    providerData?.AccessKey !== "" &&
                                    isConnected
                                      ? connected
                                      : disconnect
                                  }
                                  alt=""
                                />
                                <span>
                                  {providerData?.AccessKey
                                    ? "接続解除"
                                    : "接続する"}
                                </span>
                              </Button>
                            </div>
                          </div>
                        </ListGroup.Item>
                      )}
                      {obtainType === "lan_scope" && (
                        <ListGroup.Item className="w-100 d-flex align-items-start relative-container">
                          <div className="w-25 item-label">接続</div>
                          <div className="w-100 d-flex flex-column gap-2">
                            <span className="guild-text">
                              取得するサーバー先を設定してください
                            </span>
                            <div className="d-flex gap-2 connection-container">
                              {providerData?.LanScopeAccessToken !== "" &&
                                providerData?.LanScopeAccessToken !==
                                  undefined &&
                                providerData?.LanScopeAccessToken && (
                                  <>
                                    <span>LANSCOPE</span>
                                    <span>に接続中</span>
                                  </>
                                )}
                              <Button
                                disabled={!isEditing || isSuperAdmin}
                                className={`bg-white sync-button card-content ${
                                  !isEditing ? "button-disabled" : ""
                                }`}
                                onClick={handleShowInputLs}
                              >
                                <img
                                  src={
                                    providerData?.LanScopeAccessToken !== "" &&
                                    providerData?.LanScopeAccessToken !==
                                      undefined &&
                                    providerData?.LanScopeAccessToken
                                      ? connected
                                      : disconnect
                                  }
                                  alt=""
                                />
                                <span>
                                  {providerData?.LanScopeAccessToken !== "" &&
                                  providerData?.LanScopeAccessToken !==
                                    undefined &&
                                  providerData?.LanScopeAccessToken
                                    ? "接続解除"
                                    : "接続する"}
                                </span>
                              </Button>
                            </div>
                          </div>
                        </ListGroup.Item>
                      )}
                      {isRegistering &&
                        isRegistering !== null &&
                        obtainType === "s3" && (
                          <>
                            {awsFields.map((item, index) => (
                              <ListGroup.Item
                                key={index}
                                className="w-100 d-flex align-items-center"
                              >
                                <div className="w-25 py-2 item-label">
                                  <span className="text-danger">*&nbsp;</span>
                                  {item.label}
                                </div>
                                <div className="w-100">
                                  <Form.Control
                                    maxLength={100}
                                    className="w-100"
                                    size="sm"
                                    value={item.value}
                                    isInvalid={fieldErrors[item.name]}
                                    onChange={(e) => {
                                      const newValue = e.target.value;
                                      setAwsFields((prev) => {
                                        const updated = [...prev];
                                        updated[index].value = newValue;
                                        return updated;
                                      });

                                      setRequestBody((prev) => ({
                                        ...prev,
                                        [item.name]: newValue,
                                      }));

                                      setFieldErrors((prev) => ({
                                        ...prev,
                                        [item.name]: false,
                                      }));
                                    }}
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {item.label} を入力してください。
                                  </Form.Control.Feedback>
                                </div>
                              </ListGroup.Item>
                            ))}
                            {isRegistering &&
                              isRegistering !== null &&
                              (providerData?.AccessKey === "" ||
                                !providerData?.AccessKey) &&
                              obtainType === "s3" && (
                                <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-3">
                                  <Button
                                    className="connection-cancel-btn cancel-register-form-button"
                                    onClick={() => {
                                      setIsRegistering(false);
                                    }}
                                  >
                                    <span>キャンセル</span>
                                  </Button>
                                  <Button
                                    className="connection-save-btn"
                                    onClick={handleCreateStorage}
                                  >
                                    <span>登録</span>
                                  </Button>
                                </ListGroup.Item>
                              )}
                          </>
                        )}
                      {isShowInputLs && obtainType === "lan_scope" && (
                        <>
                          {lanscopeFields.map((item, index) => (
                            <ListGroup.Item
                              key={index}
                              className="w-100 d-flex"
                            >
                              <div className="w-25 item-label">
                                <span className="text-danger">*&nbsp;</span>
                                {item.label}
                              </div>
                              <div className="w-100">
                                <Form.Control
                                  as={"textarea"}
                                  className="w-100 resize-vertical"
                                  size="sm"
                                  value={
                                    requestBody.lanscope_access_token || ""
                                  }
                                  isInvalid={isLanscopeInvalid}
                                  onChange={(e) => {
                                    setIsLanscopeInvalid(false);
                                    const newValue = e.target.value;
                                    setRequestBody((prev) => {
                                      const newState = {
                                        ...prev,
                                        lanscope_access_token: newValue,
                                      };
                                      requestBodyRef.current = newState;
                                      return newState;
                                    });
                                  }}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {item.label} を入力してください。
                                </Form.Control.Feedback>
                              </div>
                            </ListGroup.Item>
                          ))}
                          {isShowInputLs &&
                            (providerData?.LanScopeAccessToken === "" ||
                              !providerData?.LanScopeAccessToken) && (
                              <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-3">
                                <Button
                                  className="connection-cancel-btn cancel-register-form-button"
                                  onClick={() => {
                                      setIsShowInputLs(false);
                                      setRequestBody((prev) => {
                                          const newState = {
                                              ...prev,
                                              lanscope_access_token: "",
                                          };
                                          requestBodyRef.current = newState;
                                          return newState;
                                      });
                                  }}
                                >
                                  <span>キャンセル</span>
                                </Button>
                                <Button
                                  className="connection-save-btn"
                                  onClick={async () => {
                                    if (
                                      obtainType === "lan_scope" &&
                                      requestBodyRef.current.lanscope_access_token?.trim()
                                        .length === 0
                                    ) {
                                      setIsLanscopeInvalid(true);
                                      return;
                                    }
                                    await handleSaveConnection();                                    
                                    setIsEdting(true);                                    
                                  }}
                                >
                                  <span>登録</span>
                                </Button>
                              </ListGroup.Item>
                            )}
                        </>
                      )}
                      {!isRegistering &&
                        isRegistering !== null &&
                        obtainType === "s3" &&
                        isEditing &&
                        (providerData?.DataSource === "window" ||
                          providerData?.DataSource === "lan_scope") &&
                        !isConnected && (
                          <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-5">
                            <div className="d-flex gap-3 justify-content-center">
                              <>
                                <Button
                                  className="connection-cancel-btn connection-cancel-btn1"
                                  onClick={() => {
                                    setIsEdting(false);
                                    setObtainType(
                                      providerData.DataSource as DataSourceOption,
                                    );
                                  }}
                                >
                                  <span>キャンセル</span>
                                </Button>
                              </>
                            </div>
                          </ListGroup.Item>
                        )}
                      {((isConnected &&
                        providerData?.AccessKey !== "" &&
                        obtainType === "s3") ||
                        obtainType === "window" ||
                        (obtainType === "lan_scope" &&
                          providerData?.LanScopeAccessToken !== "" &&
                          providerData?.LanScopeAccessToken !== undefined)) && (
                        <>
                          <ListGroup.Item className="w-100 d-flex align-items-center">
                            <div className="w-25 py-2 item-label">送信設定</div>
                            <div className="w-100 d-flex gap-4 time-input-container">
                              {isEditing ? (
                                <>
                                  <div className="d-flex gap-4">
                                    {TIME_SENDING_OPTIONS.map((opt) => (
                                      <div
                                        key={opt.value}
                                        className="form-check form-check-inline enable-rule-width"
                                      >
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="isSending"
                                          id={`isSending-${opt.value}`}
                                          value={opt.value}
                                          style={{
                                            width: 16,
                                            height: 16,
                                            marginRight: "0.5rem",
                                          }}
                                          checked={
                                            isSending === (opt.value === "true")
                                          }
                                          onChange={(e) => {
                                            const newValue =
                                              e.target.value === "true";
                                            setIsSending(newValue);
                                            setRequestBody((prev) => {
                                              const newState = {
                                                ...prev,
                                                enable_event_rule: newValue,
                                              };
                                              requestBodyRef.current = newState;
                                              return newState;
                                            });
                                          }}
                                          disabled={!isEditing || isSuperAdmin}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`isSending-${opt.value}`}
                                        >
                                          {opt.label}
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                  <div className="time-input-guildtext">
                                    <TimeField
                                      disabled={!isSending}
                                      sx={{
                                        width: 73,
                                        "& .MuiInputBase-root": {
                                          height: 30,
                                          fontSize: 14,
                                          padding: 0,
                                          minHeight: 30,
                                        },
                                        "& .MuiPickersInputBase-root": {
                                          height: 30,
                                          minHeight: 30,
                                          "&.Mui-disabled": {
                                            backgroundColor: "#E5E5E5",
                                            color: "#E5E5E5 !important",
                                            cursor: "not-allowed",
                                          },
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          padding: 0,
                                        },
                                        "& input": {
                                          height: 30,
                                          padding: "0 6px",
                                        },
                                        "& .MuiPickersSectionList-root": {
                                          minHeight: 30,
                                        },
                                        "& .MuiPickersSectionList-sectionContent":
                                          {
                                            fontSize: 14,
                                            lineHeight: "30px",
                                          },
                                        "& input::placeholder": {
                                          color: "transparent",
                                        },
                                        "& input:focus::placeholder": {
                                          color: "inherit",
                                        },
                                        "& .MuiPickersInputBase-root.Mui-disabled *":
                                          {
                                            color: "#e5e5e5 !important",
                                            borderColor: "#DDDBDA !important",
                                          },
                                      }}
                                      format="HH:mm"
                                      ampm={false}
                                      value={timeValue}
                                      onChange={(newValue) => {
                                        setTimeValue(newValue);
                                        if (newValue?.isValid?.()) {
                                          setScheduleTime({
                                            hour: newValue.format("HH"),
                                            minute: newValue.format("mm"),
                                          });
                                        } else {
                                          setScheduleTime(null);
                                        }
                                      }}
                                      error={false}
                                      slotProps={{
                                        textField: {
                                          inputProps: {
                                            placeholder: "00:00",
                                          },
                                        },
                                      }}
                                    />
                                    <span className="guild-text_editing">
                                      にTeamSpiritへデータを送信
                                    </span>
                                  </div>
                                </>
                              ) : providerData?.EnableEventRule &&
                                providerData?.Hour &&
                                providerData?.Minute &&
                                isConnected ? (
                                <>
                                  <span>毎日</span>
                                  <span>
                                    {providerData.Hour.padStart(2, "0")}:
                                    {providerData.Minute.padStart(2, "0")}
                                  </span>
                                  <span className="guild-text">
                                    にTeamSpiritへデータを送信
                                  </span>
                                </>
                              ) : (
                                <span className="guild-text">送信しない</span>
                              )}
                            </div>
                          </ListGroup.Item>
                        </>
                      )}
                      {isConnected &&
                        obtainType === "s3" &&
                        !isRegistering &&
                        !isSuperAdmin && (
                          <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-5">
                            <div className="d-flex gap-3 justify-content-center">
                              {!isEditing &&
                              isConnected &&
                              providerData?.Hour !== null &&
                              providerData?.Minute !== null &&
                              providerData?.OrgId !== "" ? (
                                <Button
                                  className="bg-white edit-button"
                                  onClick={() => {
                                    setIsEdting(true);
                                  }}
                                >
                                  <span>編集</span>
                                </Button>
                              ) : (
                                <>
                                  {isConnected && providerData && (
                                    <Button
                                      className="connection-cancel-btn connection-cancel-btn2"
                                      onClick={() => {
                                        if (
                                          (providerData.Hour !== "" &&
                                            providerData.AccessKey === "") ||
                                          providerData.DataSource !== "s3"
                                        ) {
                                          setObtainType(
                                            providerData.DataSource as DataSourceOption,
                                          );
                                        }
                                        setIsEdting(false);
                                        setIsRegistering(false);
                                        setIsShowInputLs(false);
                                        setObtainType(
                                          providerData.DataSource as DataSourceOption,
                                        );
                                        setRequestBody((prev) => {
                                          const newState = {
                                            ...prev,
                                            data_source:
                                              selectingOption as DataSourceOption,
                                          };
                                          requestBodyRef.current = newState;
                                          return newState;
                                        });
                                      }}
                                    >
                                      <span>キャンセル</span>
                                    </Button>
                                  )}
                                  {providerData?.AccessKey !== "" && (
                                    <Button
                                      className="connection-save-btn"
                                      onClick={handleSaveConnection}
                                    >
                                      <span>保存</span>
                                    </Button>
                                  )}
                                </>
                              )}
                            </div>
                          </ListGroup.Item>
                        )}
                      {obtainType === "window" && (
                        <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-5">
                          <div className="d-flex gap-3 justify-content-center">
                            {!isEditing &&
                            !isSuperAdmin &&
                            providerData?.Hour !== "" &&
                            providerData?.Minute !== "" ? (
                              <Button
                                className="bg-white edit-button"
                                onClick={() => setIsEdting(true)}
                              >
                                <span>編集</span>
                              </Button>
                            ) : (
                              <>
                                {isEditing && (
                                  <>
                                    {isConnected &&
                                      providerData?.Hour !== "" &&
                                      providerData?.Minute !== "" && (
                                        <Button
                                          className="connection-cancel-btn connection-cancel-btn3"
                                          onClick={() => {
                                            setIsEdting(false);
                                            setIsRegistering(false);
                                            setIsShowInputLs(false);
                                            if (
                                              providerData?.DataSource === "s3"
                                            ) {
                                              setObtainType(
                                                providerData.DataSource as DataSourceOption,
                                              );
                                              setIsConnected(false);
                                              setIsEdting(false);
                                            }
                                            setObtainType(
                                              providerData?.DataSource as DataSourceOption,
                                            );

                                            if (!providerData?.Hour) {
                                              setIsEdting(true);
                                            }
                                          }}
                                        >
                                          <span>キャンセル</span>
                                        </Button>
                                      )}
                                    {isConnected &&
                                      providerData?.Hour === "" &&
                                      providerData?.Minute === "" &&
                                      providerData.EnableEventRule ===
                                        false && (
                                        <Button
                                          className="connection-cancel-btn connection-cancel-btn4"
                                          onClick={() => {
                                            setIsEdting(false);
                                            setIsShowInputLs(false);
                                            setObtainType(
                                              providerData?.DataSource as DataSourceOption,
                                            );
                                          }}
                                        >
                                          <span>キャンセル</span>
                                        </Button>
                                      )}
                                    <Button
                                      className="connection-save-btn"
                                      onClick={handleSaveConnection}
                                    >
                                      <span>保存</span>
                                    </Button>
                                  </>
                                )}
                                {!isEditing &&
                                  providerData?.EnableEventRule === false &&
                                  isConnected && (
                                    <Button
                                      className="bg-white edit-button"
                                      onClick={() => setIsEdting(true)}
                                    >
                                      <span>編集</span>
                                    </Button>
                                  )}
                              </>
                            )}
                          </div>
                        </ListGroup.Item>
                      )}
                      {!isEditing &&
                        obtainType === "lan_scope" &&
                        (providerData?.LanScopeAccessToken !== "" ||
                          !providerData?.LanScopeAccessToken) && (
                          <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-3">
                            <Button
                              className="bg-white edit-button"
                              onClick={() => setIsEdting(true)}
                            >
                              <span>編集</span>
                            </Button>
                          </ListGroup.Item>
                        )}
                      {isEditing &&
                        providerData?.OrgId !== "" &&
                        providerData &&
                        obtainType === "lan_scope" &&
                        !isShowInputLs &&
                        (providerData?.LanScopeAccessToken !== "" ||
                          providerData?.LanScopeAccessToken) && (
                          <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-3">
                            <Button
                              className="connection-cancel-btn connection-cancel-btn5"
                              onClick={() => {
                                setIsEdting(false);
                                setObtainType(
                                  providerData?.DataSource as DataSourceOption,
                                );
                              }}
                            >
                              <span>キャンセル</span>
                            </Button>
                            {isEditing && providerData.LanScopeAccessToken !== '' &&  providerData.LanScopeAccessToken && (
                              <Button
                                className="connection-save-btn"
                                onClick={() => {
                                  if (
                                    obtainType === "lan_scope" &&
                                    providerData?.LanScopeAccessToken?.trim()
                                      .length === 0
                                  ) {
                                    setIsLanscopeInvalid(true);
                                    return;
                                  }
                                  handleSaveConnection();
                                }}
                              >
                                <span>保存</span>
                              </Button>
                            )}
                          </ListGroup.Item>
                        )}
                        {/*{isEditing && obtainType === 'lan_scope' && !isShowInputLs && ! providerData?.LanScopeAccessToken && (
                          <ListGroup.Item className="d-flex justify-content-center p-4 d-grid gap-3">
                            <Button
                              className="connection-cancel-btn"
                              onClick={() => {
                                setIsEdting(false);
                                setObtainType(
                                  providerData?.DataSource as DataSourceOption,
                                );
                                if (providerData?.DataSource === 's3') {
                                  setIsEdting(true);
                                }
                              }}
                            >
                              <span>キャンセル</span>
                            </Button>
                          </ListGroup.Item>
                        )}*/}
                    </ListGroup>
                  </Form>
                </Card>

                <Card className="mt-3 card-container">
                  <ListGroup variant="flush">
                    <Form>
                      {providerData?.OrgId && (
                        <ListGroup.Item className="w-100 align-items-center">
                          <Row>
                            <div className="w-25 item-label">
                              <p className="mb-0 mt-2">マッピング</p>
                            </div>
                            <div className="w-75">
                              <div>
                                <button
                                  onClick={(e) => {
                                    setShowModalMapping(true);
                                    e.preventDefault();
                                  }}
                                  className="bg-white edit-button btn btn-primary mb-2 modal-open-btn"
                                >
                                  マッピング設定をする
                                </button>
                              </div>
                              <div className="d-flex connection-container w-100">
                                <div className="salesforce-fields-connected_container w-100">
                                  <div className="salesforce-fields-connected_container w-100">
                                    <span>マッピング項目</span>

                                    <div
                                      className="salesforce-fields-connected_explain_button"
                                      onClick={() =>
                                        setIsShowDataExplainModal(true)
                                      }
                                    >
                                      送信データ形式について
                                    </div>

                                    {/* --- View Mode Table --- */}
                                    <div className="salesforce-fields-connected_table w-100">
                                      <Table className="mb-0 s3-connection-table outer-border-only">
                                        <thead className="connection-list-thead">
                                          <tr>
                                            <th
                                              style={{
                                                // width: "35%",
                                                minWidth: "120px",
                                              }}
                                            >
                                              表示ラベル
                                            </th>
                                            <th>API参照名</th>
                                            <th
                                              className="text-center"
                                              style={{
                                                minWidth: "80px",
                                              }}
                                            >
                                              取得列
                                            </th>
                                            <th
                                              style={{
                                                width: "55%",
                                                minWidth: "25%",
                                              }}
                                            >
                                              変換
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {tableFields?.map((row) => (
                                            <tr key={row.ApiName}>
                                              <td>{row.Name}</td>
                                              <td>
                                                <span
                                                  title={row.ApiName}
                                                  className="formula-value-trim api-name-max-length"
                                                >
                                                  {row.ApiName}
                                                </span>
                                              </td>
                                              <td className="text-center">
                                                <div
                                                  className={`formula-value-trim ${
                                                    row.NotSend ? "mg-left" : ""
                                                  }`}
                                                >
                                                  {row.NotSend
                                                    ? "送信しない"
                                                    : row.Index || ""}
                                                </div>
                                              </td>
                                              <td>
                                                <div
                                                  className="formula-value-trim"
                                                  title={row.ConvertRule.trim()}
                                                >
                                                  {row.NotSend
                                                    ? ""
                                                    : row.ConvertRule.trim() ||
                                                      "未設定"}
                                                </div>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    </div>

                                    <Modal
                                      show={showModalMapping}
                                      onHide={() => setShowModalMapping(false)}
                                      size="xl"
                                      centered
                                    >
                                      <Modal.Header
                                        className="formula-modal-header"
                                        closeButton
                                      >
                                        <Modal.Title className="mapping-modal-title">
                                          取得列・変換の設定
                                        </Modal.Title>
                                      </Modal.Header>

                                      <Modal.Body>
                                        {obtainType !== "lan_scope" && (
                                          <>
                                            <Row>
                                              <Col
                                                xs={4}
                                                md={2}
                                                className="d-flex align-items-center"
                                              >
                                                <p className="fs-13 mp-0">
                                                  出力フィールド
                                                </p>
                                              </Col>
                                              <Col xs={8} md={10}>
                                                <FormControlLabel
                                                  control={
                                                    <Checkbox
                                                      checked={hasHeaderCsv}
                                                      size="small"
                                                      onChange={(e) => {
                                                        setHasHeaderCsv(
                                                          e.target.checked,
                                                        );
                                                        setRequestBody(
                                                          (prev) => ({
                                                            ...prev,
                                                            has_header_csv:
                                                              e.target.checked,
                                                          }),
                                                        );
                                                      }}
                                                    />
                                                  }
                                                  label="ヘッダー行を除く"
                                                  sx={{
                                                    "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "13px",
                                                        color: "#181818",
                                                        fontFamily: "Roboto",
                                                      },
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </>
                                        )}
                                        <Row className="mt-3">
                                          <Col xs={4} md={2}>
                                            <p className="fs-13">
                                              マッピング項目
                                            </p>
                                          </Col>
                                          <Col xs={8} md={10}>
                                            <Table className="mb-0 s3-connection-table outer-border-only">
                                              <thead className="connection-list-thead">
                                                <tr>
                                                  <th
                                                    style={{
                                                      width: "20%",
                                                      minWidth: "120px",
                                                    }}
                                                  >
                                                    表示ラベル
                                                  </th>
                                                  <th style={{ width: "20%" }}>
                                                    API参照名
                                                  </th>
                                                  <th
                                                    style={{
                                                      width: "15%",
                                                      minWidth: "80px",
                                                    }}
                                                  >
                                                    取得列
                                                  </th>
                                                  <th>変換</th>
                                                  <th
                                                    className="text-center"
                                                    style={{ width: "10%" }}
                                                  ></th>
                                                </tr>
                                              </thead>

                                              <tbody>
                                                {tableFields?.map((row) => (
                                                  <tr key={row.ApiName}>
                                                    <td>{['Email__c','EmpId__c','EmpCode__c'].includes(row.ApiName) ? '*' : ''}{row.Name}</td>
                                                    <td>
                                                      <span
                                                        title={row.ApiName}
                                                        className="formula-value-trim api-name-max-length"
                                                      >
                                                        {row.ApiName}
                                                      </span>
                                                    </td>

                                                    {/* 取得列 */}
                                                    <td
                                                      className={`not-padding-side ${
                                                        duplicateIndexes.includes(
                                                          row.Index,
                                                        )
                                                          ? "duplicate-index"
                                                          : ""
                                                      } ${
                                                        row.NotSend
                                                          ? "not-send-bg"
                                                          : ""
                                                      }`}
                                                    >
                                                      <div
                                                        title={row.ConvertRule.trim()}
                                                        className="editing-background padding-l"
                                                      >
                                                        {row.NotSend
                                                          ? "送信しない"
                                                          : row.Index || ""}
                                                      </div>
                                                    </td>

                                                    {/* 変換数式 */}
                                                    <td
                                                      className={`not-padding-side ${
                                                        row.NotSend
                                                          ? "not-send-bg"
                                                          : ""
                                                      }`}
                                                    >
                                                      <div className="editing-background">
                                                        <div className="formula-value formula-value-trim">
                                                          {row.NotSend
                                                            ? ""
                                                            : row.ConvertRule.trim() ||
                                                              ""}
                                                        </div>
                                                      </div>
                                                    </td>

                                                    {/* ボタン */}
                                                    <td className="not-padding-side">
                                                      <div
                                                        className={`editing-background padding-r ${
                                                          row.NotSend
                                                            ? "not-send-bg"
                                                            : ""
                                                        }`}
                                                      >
                                                        <Button
                                                          onClick={() =>
                                                            handleOpenFormulaModal(
                                                              row,
                                                            )
                                                          }
                                                          style={{
                                                            height: "32px",
                                                            minWidth: "58px",
                                                            marginRight: "12px",
                                                          }}
                                                          className="edit-index_btn"
                                                          variant="outline-primary"
                                                        >
                                                          編集
                                                        </Button>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </Table>

                                            <div className="salesforce-table-guild-text mt-2">
                                              *がついている表示ラベルは、いずれか1つ以上の取得列の設定が必要です。
                                            </div>
                                          </Col>
                                        </Row>
                                      </Modal.Body>

                                      <Modal.Footer>
                                        <Button
                                          variant="light"
                                          size="sm"
                                          className="modal-btn modal-cancel-btn"
                                          onClick={() =>
                                            setShowModalMapping(false)
                                          }
                                        >
                                          キャンセル
                                        </Button>
                                        <Button
                                          variant="primary"
                                          onClick={handleMapping}
                                          className="modal-save-btn"
                                        >
                                          マッピングを保存
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Row>
                        </ListGroup.Item>
                      )}
                    </Form>
                  </ListGroup>
                </Card>
              </div>
            )}
            {activeTab === "terminal-employee-mapping" && (
              <>
                <div className="provider-settings flex-grow-1 p-4">
                  <Card className="card-container">
                    <Card.Body className="page-title">
                      端末社員マッピング
                    </Card.Body>
                  </Card>
                  <TerminalMapping />
                </div>
              </>
            )}

            {activeTab === "logs" && (
              <>
                <AccessControlLog />
              </>
            )}
          </div>
          {showModal && (
            <FormulaModal
              show={showModal}
              currentField={currentField}
              onClose={() => setShowModal(false)}
              value={currentFormula}
              onChange={(val: FormulaValue) => {
                setCurrentFormula(val);
              }}
              onSave={handleSaveFormula}
              currentObtainType={obtainType}
              initialValue={(() => {
                const val = initialFormula[currentField ?? ""];
                if (!val)
                  return { index: undefined, convertRule: "", notSend: false };
                return typeof val === "string"
                  ? { index: 999, convertRule: val, notSend: false }
                  : val;
              })()}
            />
          )}
        </Fragment>
      )}
    </div>
  );
}
